declare namespace $ {

	export class $mol_icon_console extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=console.view.tree.d.ts.map